import {AngularFirestore, QuerySnapshot} from 'angularfire2/firestore';
import {firestore} from 'firebase';
import {Injectable} from '@angular/core';

@Injectable()
export class UserService {
  constructor(private db: AngularFirestore) {
    console.log('creating event service');
  }

  public fetchUser(username: String): Promise<UserDto> {
    const users: firestore.CollectionReference = this.db.firestore.collection('users');
    const query = users.where('userName', '==', username);
    const promise = new Promise<UserDto>((resolve, reject) => {
      return query.get().then((snapshot: QuerySnapshot<UserDto>) => {
        // console.log(snapshot.docs[0].data());
        return resolve(snapshot.docs[0].data());
      }).catch((error) => {
        reject(error);
      });
    });
    return promise;
  }

  public fetchAllUser(): Promise<UserDto[]> {
    const users: firestore.CollectionReference = this.db.firestore.collection('users');
    // const query = users.where('userName', '==', username);
    const promise = new Promise<UserDto[]>((resolve, reject) => {
      const userDtos: UserDto[] = [];
      return users.get().then((snapshot: QuerySnapshot<UserDto>) => {
        snapshot.docs.forEach(doc => {
          userDtos.push(doc.data());
        });
        return resolve(userDtos);
      }).catch((error) => {
        reject(error);
      });
    });
    return promise ;
  }
}

/**
 * we should not expose user sensitive data
 * do not read user's sensitive data that we don't need in front end application
 */
export interface UserDto {
  /** Company **/
  company: string;
  companyDesc: string;
  companyCurrency: string;
  companyGdprURI: string;
  companyTermsURI: string;
  displayName: string;
  email: string;
  companyAddress: string;
  testUser: boolean;

  /** User **/
  name: String;
  lastName: String;
  mobileNo: String;
  userName: String;
  photoURL: String;
  uid: String;

  /** MAILJET **/
  // mailjetAPIKey: String;
  // mailjetSecretKey: String;
  // ticketMailTemplateID: String;

  /** PASSSLOT **/
  // passslotAPIKey: String;
  // passslotTempName: String;

  /** PAYSON **/
  // paysonAPIKey: String;
  paysonIntegration: Boolean;

  /** SWISH **/
  // swishCaFileName: String;
  // swishCertFileName: String;
  // swishKeyFileName: String;
  // companySwishNumber: String;
  // swishPassword: String;
  swishIntegration: Boolean;

  /** STRIPE **/
  stripeIntegration: Boolean;
}
